import { uiSize } from '@utils'

interface Props {
  color?: string
}

function WithdrawIcon({ color = 'currentColor' }: Props) {
  return (
    <svg
      width={uiSize(14)}
      height={uiSize(14)}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='2.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 15V4M7.5 8.5 12 4l4.5 4.5M4 15v4h16v-4' />
    </svg>
  )
}

export default WithdrawIcon
